import {setCommonColors, setDefaultColors, setHighContrastColor} from './setColors';


const mixin = {
  data(){
    return {
      CHECK_APP_CONTRAST: false,
    }
  },
  computed: {
    isAppHighContrast(){
      return this.$store.getters['highContrast'];
    }
  },
  created(){
    if(this.CHECK_APP_CONTRAST){
      this.$store.dispatch('UPDATE_HIGH_CONTRAST');
    }
  },
  beforeMount() {
    setCommonColors();
    this.checkAppHighContrastColors();
  },
  methods: {
    checkAppHighContrastColors(){
      this.RESET_DEFAULT_COLORS();

      if(this.CHECK_APP_CONTRAST && this.isAppHighContrast){
        setHighContrastColor();
        document.documentElement.classList.add('app-high-contrast');
      }
      else{
        setDefaultColors();
        document.documentElement.classList.remove('app-high-contrast');
      }
    }
  },
  watch: {
    isAppHighContrast(){
      if(this.CHECK_APP_CONTRAST){
        this.checkAppHighContrastColors();
      }
    },
  }
};

export default mixin;
